import { Backdrop, Overlay, Body, Footer, Header } from './SlideOut';
import { RxCross1 } from 'react-icons/rx';

const BasicSlideOut = ({ showSlideOut, hideSlideOut, title, body, submitText, onSubmit }) => {
  return (
    <>
      <Backdrop
        show={showSlideOut}
        onClick={hideSlideOut}
      />
      <Overlay show={showSlideOut}>
        <Header>
          <h2>{title}</h2>
          <RxCross1
            size={24}
            onClick={hideSlideOut}
            style={{ cursor: 'pointer' }}
          />
        </Header>
        <Body>{body}</Body>
        <Footer>
          <button
            className="primary"
            onClick={onSubmit}>
            {submitText}
          </button>
        </Footer>
      </Overlay>
    </>
  );
};

export default BasicSlideOut;
